import { I18nextContext } from "@bond-london/gatsby-plugin-cms-i18next";
import { graphql, useStaticQuery } from "gatsby";
import React, { useContext } from "react";
import { getSvg } from "../components/Blocks";
import { NavigationDrawer } from "../elements/NavigationDrawer";

// eslint-disable-next-line import/no-unused-modules
export const ExternalLinkFragment = graphql`
  fragment ExternalLink on GraphCMS_ExternalLink {
    title
    url
  }
`;

// eslint-disable-next-line import/no-unused-modules
export const ContactInformationFragment = graphql`
  fragment ContactInformation on GraphCMS_ContactInformation {
    title
    address {
      cleaned
    }
    locale
    otherInformation {
      cleaned
    }
  }
`;

// eslint-disable-next-line import/no-unused-modules
export const MainNavigationFragment = graphql`
  fragment MainNavigation on GraphCMS_MainNavigation {
    id
    actualLocale
    logo {
      ...Svg
    }
    pageLinks {
      ...PageLinkFull
    }
    contactInformation {
      ...ContactInformation
    }
    externalLinkSelection {
      id
      title
      externalLinks {
        ...ExternalLink
      }
    }
  }
`;

export const MainNavigation: React.FC<{
  corePath: string;
}> = ({ corePath }) => {
  const data = useStaticQuery<Queries.AllMainNavigationQuery>(graphql`
    query AllMainNavigation {
      allGraphCmsMainNavigation {
        nodes {
          ...MainNavigation
        }
      }
    }
  `);
  const i18next = useContext(I18nextContext);
  const currentLanguage = i18next.currentLanguage;

  const languageNavigation = data.allGraphCmsMainNavigation.nodes.filter(
    (n) => n.actualLocale === currentLanguage,
  );
  const firstNavigation =
    languageNavigation.length > 0 ? languageNavigation[0] : null;
  if (!firstNavigation) return null;
  return (
    <NavigationDrawer
      corePath={corePath}
      navigation={firstNavigation}
      logo={getSvg(firstNavigation.logo)}
    />
  );
};
